export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			companyReportTypes: [
				{name: "RPK", value: "RPK"},
				{name: "CWK", value: "CWK"},
				{name: "Journal", value:"Journal"}
			],
		}
	}
};